import * as React from "react";
import type { SVGProps } from "react";
const FreeKick = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fill="#FFF"
        d="M2 16.75a.75.75 0 0 1-.75-.75V9c0-1.34.96-2.46 2.24-2.7a2.75 2.75 0 1 1 3.02 0c.89.16 1.62.76 1.99 1.55.37-.8 1.1-1.39 1.99-1.55a2.75 2.75 0 1 1 3.02 0A2.75 2.75 0 0 1 15.75 9v7c0 .41-.34.75-.75.75z"
      />
      <path
        fill="#000"
        d="M6 7a2 2 0 0 1 2 2v7H2V9c0-1.1.9-2 2-2zM5 2a2 2 0 0 1 .15 4H5a2 2 0 0 1-.15-4z"
      />
      <path
        fill="#0085CC"
        d="M6 8H4a1 1 0 0 0-1 1v6h4V9a1 1 0 0 0-.88-1zM5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
      <path
        fill="#000"
        d="M13 7a2 2 0 0 1 2 2v7H9V9c0-1.1.9-2 2-2zm-1-5a2 2 0 0 1 .15 4H12a2 2 0 0 1-.15-4z"
      />
      <path
        fill="#0085CC"
        d="M13 8h-2a1 1 0 0 0-1 1v6h4V9a1 1 0 0 0-.88-1zm-1-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
      <path
        fill="#FFF"
        d="M19 16.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5"
      />
      <path fill="#000" d="M19 17a3 3 0 1 1 0 6 3 3 0 0 1 0-6" />
      <path fill="#C5C5C5" d="M19 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
      <path
        fill="#FFF"
        d="M21.1 7.43c.12.46-.03.92-.35 1.23l-.06.05c.98.9 1.66 1.91 2.01 3.04.51 1.6.5 3.07-.03 4.36a1.25 1.25 0 1 1-2.31-.97c.3-.71.3-1.58-.04-2.64a4.2 4.2 0 0 0-.92-1.54l-.14-.15-.01.02c-.15.25-.39.45-.7.56l-.13.04-.15.03c-.69.06-1.3-.46-1.35-1.14l-.17-1.95c-.05-.6.34-1.15.92-1.31l1.89-.51c.66-.18 1.35.21 1.53.88Z"
      />
      <path
        fill="#000"
        d="M20.37 7.62a.5.5 0 0 1-.35.62l-.85.23c1.45 1 2.4 2.17 2.82 3.5a5.5 5.5 0 0 1-.02 3.85.5.5 0 0 1-.92-.39c.37-.88.37-1.93-.01-3.15a5.9 5.9 0 0 0-2.45-3l.07.89a.5.5 0 0 1-.37.52l-.08.02a.5.5 0 0 1-.54-.46l-.17-1.94a.5.5 0 0 1 .37-.53l1.88-.5a.5.5 0 0 1 .62.34"
      />
    </g>
  </svg>
);
export default FreeKick;
